import Service from '../abstract/service'
import Empresa from '../empresa'

export default class Inadimplencia extends Service {
  constructor() {
    super()
    this._inadimplenciaRef = this._db.collection(
      `${this._prefix}-gruposEmpresas/${this._grupoPrincipal}/Inadimplencia`
    )

    this._serviceEmpresa = new Empresa()
  }

  async create(values) {
    try {
      this._loading.setLoading(true, 'Cadastrando faixa de inadimplência')
      let doc = await this._inadimplenciaRef.doc(`${values.apelido}`+`${values.papel.toUpperCase()}`)
      await doc.set(values)
      values.id = doc.id

      return Promise.resolve(values)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }

  async update(inadimplenciaId, values) {
    try {
      this._loading.setLoading(true, 'Atualizando faixa de inadimplência')
      delete values.id
      const inadimplencia = await this._inadimplenciaRef.doc(inadimplenciaId)
      inadimplencia.update({
        ...values
      })

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
  
  async delete(inadimplenciaId) {
    try {
      this._loading.setLoading(true, 'Deletando faixa de inadimplência')
      const inadimplencia = await this._inadimplenciaRef.doc(inadimplenciaId)
      inadimplencia.delete()

      return Promise.resolve()
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }



  async getByEmpresaPapel(items, dat) {
    let inadimplencia = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de inadimplência')
      for (let item of items.empresas) {
        const empresa = dat.find(element => element.cnpj === item);

        const response = await this._inadimplenciaRef
          .where("empresa", "==", empresa.cnpj)
          .where("papel", "==", items.papel)
          .get();

        if (!response.empty) {
          for (let doc of response.docs) {
            let faixa = doc.data();

            inadimplencia.push({
              id: doc.id,
              nomeEmpresa: empresa.nome,
              ...faixa
            });
          }
        }
      }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }

  async getByCnpjPapel(cnpj, papel) {
    let inadimplencia = new Array()
    try {
      this._loading.setLoading(true, 'Carregando faixas de inadimplência')

        const response = await this._inadimplenciaRef
          .where("empresa", "==", cnpj)
          .where("papel", "==", papel)
          .get();
          
        if (!response.empty) {
          for (let doc of response.docs) {
            inadimplencia.push(doc.data());
          }
        }
      return Promise.resolve(adimplencia);
    } catch (error) {
      console.log("erro", error);
      console.error("Erro:", error);
      return Promise.reject(error);
    } finally {
      this._loading.setLoading(false);
    }
  }



  async getAll() {
    try {
      this._loading.setLoading(true, 'Buscando todas faixas de inadimplencia')
      const response = await this._inadimplenciaRef.get()

      let inadimplencia = new Array()
      if (!response.empty) {
        for (let doc of response.docs) {
          inadimplencia.push({
            id: doc.id,
            ...doc.data()
          })
        }
      }

      return Promise.resolve(inadimplencia)
    } catch (error) {
      return Promise.reject(error)
    } finally {
      this._loading.setLoading(false)
    }
  }
}
